import {Dispatcher, EventBus, BusEvent, EventBusRegistry} from 'dispatcher'
import {
  CHAT_ERROR_TYPE,
  WS_CHAT_TYPE_VALUE,
  WS_DATA_VALUE_CMD,
  WS_DIRECT_MESSAGE_ERROR_DATA
} from 'ws'

export abstract class Command<D, M> {
  // Used to intercept response from ws after execution
  protected abstract uuid: string
  // Cmd name send to ws
  protected abstract cmd: string
  // Dispatcher to catch the incoming event
  protected abstract dispatcher: Dispatcher<D, M>
  // EventBusRegistry to free once the response is received
  protected registry?: EventBusRegistry
  // AppEvent Data
  protected abstract data: object | undefined
  // AppEvent Meta
  protected abstract meta: object | undefined

  constructor(protected eventBus: EventBus) {}

  execute(): Promise<BusEvent<D, M>> {
    return new Promise((resolve, reject) => {
      this.registry = this.dispatcher.register((event) => {
        if (
          (event as unknown as BusEvent<WS_DIRECT_MESSAGE_ERROR_DATA, M>).data!
            .type === CHAT_ERROR_TYPE
        ) {
          reject(
            new Error(
              '' +
                (event as unknown as BusEvent<WS_DIRECT_MESSAGE_ERROR_DATA, M>)
                  .data!.data.code
            )
          )
        } else {
          resolve(event)
        }
        this.registry?.unregister()
      })
      const event = {
        type: WS_CHAT_TYPE_VALUE,
        data: {
          type: WS_DATA_VALUE_CMD,
          data: {
            id: this.uuid,
            cmd: this.cmd,
            ...this.data
          },
          meta: this.meta
        },
        scope: 'WS'
      }
      this.eventBus.fire(event)
    })
  }

  public onComplete() {
    this.registry?.unregister()
  }
}

export class WSCommandProcessor {
  private ttl = 15000

  async execute<D, M>(cmd: Command<D, M>) {
    return new Promise<BusEvent<D, M>>((resolve, reject) => {
      const timer = setTimeout(() => {
        cmd.onComplete()
        reject(new Error('Timeout'))
      }, this.ttl)
      cmd
        .execute()
        .then((r) => {
          clearTimeout(timer)
          resolve(r)
        })
        .catch((r) => reject(r))
    })
  }
}
